<div class="modal-header">
    <h4 class="modal-title pull-left">{{title}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
    <div id="content">
        <div class="row">
            <div class="col-md-3">
                <label>Selected Identifier:</label>
                <button class="btn btn-primary float-right" (click)="addNew()">Add New</button>
                <br>
                <div class="mt-2">
                    <input type="text" class="form-control" placeholder="Search here..." (input)="findIdentifiers($event)">
                </div>
                <div id="content"
                    style="height: 423px; width: 100%; margin-top: 5px;overflow-y: auto; overflow-x: hidden; border-bottom: solid 1px black;"
                    [ngClass]="{'disableDiv': showButton}"> <!-- width: 250px; -->
                    <div class="titlebox"></div>
                    <div class="scroll">
                        <div class="row mx-2">
                            <div class="fixTableHead" style="width: 100%;">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let identifier of identifierList">
                                            <td><label style="cursor: pointer;" class="text-center"
                                                    (click)="setForm(identifier)">
                                                    {{identifier.name}}
                                                </label></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-9 pl-0 pt-2">
                <label>Identifier Information:</label>
                <div id="content">
                    <div class="titlebox"></div>
                    <form [formGroup]="identifierFormGroup">
                        <div class="row">
                            <div class="col-md-8">
                                <label>Name:</label>
                                <input type="text" class="form-control" formControlName="name"
                                    [(ngModel)]="identifierModel.name">
                            </div>
                        </div>
                        <div class="pt-2 col-md-12 text-center">
                            <button class="btn btn-primary px-4" (click)="edit()" *ngIf="!showButton"
                                [disabled]="!enablEditButton">Edit</button>
                            <button class="btn btn-primary px-4 mx-2" [disabled]="identifierFormGroup.invalid"
                                *ngIf="showButton" (click)="save()">Save</button>
                            <button class="btn btn-primary px-4" (click)="cancel()" *ngIf="showButton">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <!-- <button type="button" class="btn btn-default" (click)="save()">Save</button> -->
    <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">Close</button>
</div>
